import { Container, Step, StepButton, StepLabel, Stepper } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IFormManage } from "../_common/models/form/formManage.model";
import { getStringDateNormalized } from "../_helpers/dateTime.helper";
import { formService } from "../_services/form.service";
import { FormSectionManage } from "./formSection/formSection-manage";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { PrimaryButton } from "../_components/button/primary.button";
import { toastr } from "../_components/toastr/toastr";

export function FormShoppingCart() {
    const navigate = useNavigate();

    const { formId } = useParams<{ formId: string }>();
    const _formId = Number(formId);

    const editorRef = useRef(null);
    const [data, setData] = useState<IFormManage>();

    const [isLoading, setLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [showReview, setShowReview] = useState(false);

    const [activeStep, setActiveStep] = React.useState<number>(0);
    const [stepWithLatestId, setStepWithLatestId] = React.useState<number | null>(null);

    useEffect(() => {
        fetchData();

    }, []);

    useEffect(() => {
        if (data) {
            if (activeStep === 0 || shouldShowReviewSection()) {
                resetActiveStep();
            }

            resetStepWithLatestId();
        }
    }, [data]);

    function fetchData(isOnSave?: boolean) {

        setLoading(true);

        return formService
            .getShoppingCart(_formId)
            .then(
                (json) => {
                    setData(json);
                }
            )
            .finally(() => {
                setLoading(false);
                if (isOnSave == true) {
                    setIsSaving(false);
                }
            });
    }

    function completeForm() {
        setIsSaving(true);

        return formService
            .complete(_formId)
            .then(
                (json) => {
                    toastr.success("success")
                }
            )
            .finally(() => {
                setIsSaving(false);
            });
    }

    function onSave() {
        triggerNextStep(true);

        // if (data?.formSectionList[activeStep].isConsentSection === true) {
        //     setLoading(true);
        //     setIsSaving(true);
        //     return formService
        //         .hasConsent(_formId)
        //         .then(
        //             (json) => {
        //                 if (json === true) {
        //                     triggerNextStep();
        //                 }
        //                 else {
        //                     navigate("/");
        //                 }
        //             }
        //         )
        //         .finally(() => {
        //             setLoading(false);
        //             setIsSaving(false);
        //         });
        // }
        // else {
        //     triggerNextStep(true);
        // }
    }

    function triggerNextStep(isOnSave?: boolean) {
        if (activeStep == getActiveStep()) {
            setActiveStep(activeStep + 1);
            setStepWithLatestId(((stepWithLatestId || 0) + 1));
        }
        else {
            setActiveStep(getActiveStep());
        }

        fetchData(isOnSave);
    }

    function getActiveStep() {
        let step: number | null = null;

        if (shouldShowReviewSection()) {
            return data?.formSectionList.length || 0;
        }

        if (data && data.formSectionList.length > 0) {

            // let _section = (data.formStatusId == FormStatusEnum.NoConsent) ?
            //     data.formSectionList.find(section => section.isConsentSection === true) :
            //     data.formSectionList.find(section => !section.id);

            // if (_section) step = data.formSectionList.indexOf(_section);
            // else step = data.formSectionList.length;
            data.formSectionList.forEach((item, index) => {
                if (!item.id && step === null) {
                    step = index;
                }
            })
        }
        return step || 0;
    }

    function resetActiveStep() {
        setActiveStep(getActiveStep());
    }

    function resetStepWithLatestId() {

        let step: number | null = null;
        if (data && data.formSectionList.length > 0) {
            data.formSectionList.forEach((item, index) => {
                if (item.id) {
                    step = index;
                }
            })
        }
        setStepWithLatestId(step);
    }

    function shouldShowReviewSection() {

        let shouldShowReview = false;
        if (data && data.formSectionList.length > 0) {
            shouldShowReview = !data.formSectionList.some((item, index) => {
                return !item.id
            })
        }
        return shouldShowReview;
        // return (activeStep !== null && data && data.formSectionList.length > 0 &&
        //     (
        //         (
        //             data.formStatusId == FormStatusEnum.Completed
        //         ) ||
        //         (
        //             data.formStatusId == FormStatusEnum.NoConsent && !data.isFormOwner
        //         )
        //             (accountService.isAdmin && showReview === true))
        // );
    }

    function shouldShowManageSection() {
        return true;
        // return (activeStep !== null && data &&
        //     stepWithLatestId != null &&
        //     data.formSectionList.length > 0 &&
        //     !(
        //         data.formStatusId == FormStatusEnum.Completed
        //     ) &&
        //     !(
        //         data.formStatusId == FormStatusEnum.NoConsent && !data.isFormOwner
        //     ) &&
        //     !(
        //         data.formTemplateTypeId == FormTemplateTypeEnum.EmployerQuestionnaire && !data.isFormOwner
        //     ) &&
        //     !(
        //         data.formTemplateTypeId == FormTemplateTypeEnum.EmployeeQuestionnaire && !data.isFormOwner
        //     ) &&
        //     activeStep < data.formSectionList.length &&
        //     (
        //         (data.formTemplateTypeId == FormTemplateTypeEnum.EmployeeRiskAssessment && accountService.isAssessor && (stepWithLatestId === -1 || data.formSectionList[stepWithLatestId].formTemplateSectionTypeId != FormTemplateSectionTypeEnum.AssessorSignature)) ||
        //         (data.formTemplateTypeId != FormTemplateTypeEnum.EmployeeRiskAssessment && !accountService.isAssessor) ||
        //         (data.formTemplateTypeId == FormTemplateTypeEnum.EmployeeRiskAssessment && !accountService.isAssessor && stepWithLatestId > 0 && data.formSectionList[stepWithLatestId].formTemplateSectionTypeId == FormTemplateSectionTypeEnum.AssessorSignature)
        //     ) &&
        //     showReview !== true);
    }

    const isReviewSection = activeStep === data?.formSectionList.length;

    return (
        <>
            {/* <ValidatorForm onError={(e) => { console.log("err", e); }} onSubmit={(e) => { e.preventDefault(); console.log("submit"); }} noValidate>

                <TextValidator
                    label={"test"}
                    value={""}
                    name={"test"}
                    fullWidth
                    type={"text"}
                    onChange={(e: any) => { }}
                />

                <PrimaryButton icon={"check"} variant="success" type="submit">Continue</PrimaryButton>
            </ValidatorForm> */}

            <Container>
                {(activeStep !== null && data && data.formSectionList.length > 0) &&
                    <>

                        <h2 style={{ textAlign: "center" }}>{data.name}</h2>

                        {data.dateCompleted &&
                            <h6>Completed Date: {getStringDateNormalized(data.dateCompleted, true)}</h6>
                        }
                        <Stepper activeStep={activeStep} alternativeLabel >


                            {data.formSectionList.map((listItem, index) => {
                                const stepProps: { completed?: boolean } = {};
                                stepProps.completed = (listItem.id || 0) > 0 || index < activeStep;

                                return (
                                    <Step key={index + "_" + listItem.id} {...stepProps}>
                                        <StepButton disabled={stepWithLatestId === null || (!listItem.id && (stepWithLatestId + 1) !== index)} onClick={() => { setActiveStep(index) }}>
                                            <StepLabel>{listItem.name}</StepLabel>
                                        </StepButton>
                                    </Step>
                                );
                            })}

                            <Step key={data.formSectionList.length} disabled={false}>
                                <StepButton disabled={!shouldShowReviewSection()} onClick={() => { setActiveStep(data.formSectionList.length) }}>
                                    <StepLabel>Review</StepLabel>
                                </StepButton>
                            </Step>

                        </Stepper>
                    </>
                }

                {/* {shouldShowReviewSection() &&
                <FormSectionReviewList onSave={() => { }} />
            } */}

                {(activeStep !== data?.formSectionList.length) &&
                    <FormSectionManage
                        formTemplateSectionId={data && data.formSectionList.length > 0 && activeStep < data.formSectionList.length ? data.formSectionList[activeStep].formTemplateSectionId : 0}
                        isSectionSaving={isSaving}
                        formSectionId={data?.id}
                        onSave={onSave} />
                }

                {(data && data.formSectionList && data.formSectionList.length && isReviewSection) && data.formSectionList.map((section, index) =>
                    <FormSectionManage
                        formTemplateSectionId={section.formTemplateSectionId ?? 0}
                        isForReview
                        isSectionSaving={isSaving}
                        formSectionId={data?.id}
                        onSave={onSave} />
                )}

                {(isReviewSection) &&
                    <PrimaryButton icon={"check"} isLoading={isLoading} isSaving={isSaving} onClick={completeForm} variant="success" type="button">Complete And Go To Payment</PrimaryButton>
                }
                {/*
            {accountService.isAdmin &&
                <PrimaryButton variant="warning" type="button" onClick={() => { setShowReview(!showReview) }}>Toggle Admin Review</PrimaryButton>
            }
        */}
            </Container>
        </>
    );
}